import { PropsWithChildren, useEffect, useRef } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

import { getPostHogApiHost } from '@percent/utility';

export function PostHogProvider({ children }: PropsWithChildren) {
  const apiKey = process.env.NX_PUBLIC_POSTHOG_API_KEY;
  const initialized = useRef(false);

  useEffect(() => {
    if (!apiKey || initialized.current) return;

    posthog.init(apiKey, {
      api_host: getPostHogApiHost(window.location.hostname),
      ui_host: 'https://eu.posthog.com',
      capture_pageview: false,
      person_profiles: 'identified_only',
      disable_session_recording: true,
    });
    posthog.register({ app: 'hosted-validation-form' });
    initialized.current = true;
  }, [apiKey]);

  if (!apiKey) {
    // eslint-disable-next-line no-console
    console.warn('PostHog API key missing — feature flags will use their configured defaults');
    return <>{children}</>; // eslint-disable-line react/jsx-no-useless-fragment -- children is ReactNode; fragment normalises the return type
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
